module.exports = __webpack_public_path__ + "media/sfx_click_7.97793a15.wav";